import { Navigate, Outlet } from 'react-router-dom';
import { useOrganizationReportingAccess } from '@/hooks/useOrganizationReportingAccess';
import { ERouterNames } from '@/types';

/**
 * Guards the pages that only make sense for organizations provisioned by
 * consults per month. RequiredAuthLayout renders its routes only once the
 * current organization is resolved, so a missing organization here means
 * there is none, not that it is still loading.
 * @returns The guarded routes, redirecting anyone without access away.
 */
export const ConsultsPerMonthAccessLayout = () => {
  const { hasAccess } = useOrganizationReportingAccess();

  if (!hasAccess) return <Navigate to={ERouterNames.ROUTE_ME} replace />;

  return <Outlet />;
};
